module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('gheader'), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav'), _vm._v(" "), _c('div', {
    staticClass: "row-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "contact-info",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "form-group shanghai"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.companyname))])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_vm._v("联系部门：")]), _vm._v(_vm._s(_vm.department))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系邮箱：")]), _vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系电话：")]), _vm._v(_vm._s(_vm.telephone))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("信件邮寄地址：")]), _vm._v(_vm._s(_vm.address))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮编：")]), _vm._v(_vm._s(_vm.postCode))]), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _c('gfooter', {
    attrs: {
      "id": "contact-footer"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-box",
    staticStyle: {
      "padding-right": "500px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/szMap.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/template-compiler?{"id":"data-v-567fbffd","hasScoped":false}!./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact/contact.vue
// module id = 298
// module chunks = 7